(() => {
  document.querySelectorAll('[data-dd-rewards-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-dd-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-dd-dot]'));
    const prev = slider.querySelector('[data-dd-prev]');
    const next = slider.querySelector('[data-dd-next]');
    const autoplay = slider.dataset.autoplay === 'true';
    const interval = Number(slider.dataset.interval || 5000);
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let timer = null;

    if (slides.length < 2) return;
    if (index < 0) index = 0;

    const setSlide = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.toggleAttribute('aria-current', dotIndex === index);
      });
    };

    const restart = () => {
      if (!autoplay) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => setSlide(index + 1), interval);
    };

    prev?.addEventListener('click', () => {
      setSlide(index - 1);
      restart();
    });

    next?.addEventListener('click', () => {
      setSlide(index + 1);
      restart();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setSlide(Number(dot.dataset.ddDot || 0));
        restart();
      });
    });

    setSlide(index);
    restart();
  });
})();
